module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels-log_BW-p-1080-7dad832425a578f016111a708f7aa87c.jpg";